import { z } from 'zod';
import { ModuleTypeEnum } from './module';

export const ModuleLinkSchema = z.object({
  moduleType: z.nativeEnum(ModuleTypeEnum),
  moduleId: z.string().uuid(),
  moduleName: z.string().optional().nullable(),
  modulePath: z.string().optional().nullable(),
});

export type ModuleLink = z.infer<typeof ModuleLinkSchema>;
